import { combineReducers } from 'redux';
import { AnalyticsReducer } from '@src/analyticsManager';
import TerminateSession from '../terminateSession';
import DeviceReducer from '../../utils/device/deviceReducer';
import OptionsFilters from '../optionsFilter';
import CurrentStep from '../currentStep';
import FormState from '../formState';
import FormCompletion from '../formCompletion';
import ErrorState from '../error';
import FormSharedValues from '../formSharedValues';
import StepProgression from '../stepsProgression';
import Tour from '../tour';
import YouvisitAnalytics from '../youvisitAnalytics';
import CollegePill from '../collegePill';
import SSO from '../SSO';
import Personalization from '../personalization';

const rootReducer = combineReducers({
  device: DeviceReducer,
  optionsFilters: OptionsFilters.reducer,
  currentStep: CurrentStep.reducer,
  formState: FormState.reducer,
  completed: FormCompletion.reducer,
  errorState: ErrorState.reducer,
  formSharedValues: FormSharedValues.reducer,
  stepProgression: StepProgression.reducer,
  tour: Tour.reducer,
  analytics: YouvisitAnalytics.reducer,
  analyticsManager: AnalyticsReducer,
  terminateSession: TerminateSession.reducer,
  SSO: SSO.reducer,
  collegePill: CollegePill.reducer,
  personalizationCompleted: Personalization.reducer,
});

export default rootReducer;
